import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationBellComponent } from '../notification-bell/notification-bell.component';
import { NotificationCenterComponent } from '../notification-center/notification-center.component';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
  standalone: true,
  imports: [CommonModule, NotificationBellComponent, NotificationCenterComponent]
})
export class NotificationContainerComponent implements OnInit {
  isOpen = false;

  constructor(
    private notificationService: NotificationService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    // Make sure notifications are loaded when component is initialized
    this.notificationService.fetchNotificationsList();
  }
  
  // Toggle notification center visibility
  toggleNotifications(): void {
    this.isOpen = !this.isOpen;
  }
  
  // Close notification center when clicking outside
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
} 